// main menu toggle
for (const el of document.querySelectorAll('.open-nav-primary')) {
    el.addEventListener('click', () => {
        document.body.classList.toggle('nav-primary-open')
    })
}

for (const el of document.querySelectorAll('.nav-primary > ul > li > a')) {
    el.addEventListener('click', (e) => {
        if (document.body.classList.contains('nav-primary-open')) {
            const li = e.target.closest('li')
            const submenu = li.querySelector(':scope > ul')
            if (submenu) {
                e.preventDefault()
                const old = document.querySelector(
                    '.nav-primary > ul > li.open'
                )
                if (old && old !== li) {
                    old.classList.remove('open')
                }
                li.classList.toggle('open')
            }
        }
    })
}

for (const el of document.querySelectorAll('.close-nav-primary')) {
    el.addEventListener('click', () => {
        document.body.classList.remove('nav-primary-open')
    })
    el.addEventListener('keypress', (e) => {
        if (['Enter', 'Space'].includes(e.code)) {
            document.body.classList.remove('nav-primary-open')
        }
    })
}
